{
  "v": "5.12.1",
  "fr": 29.9700012207031,
  "ip": 0,
  "op": 96.0000039101602,
  "w": 1080,
  "h": 1080,
  "nm": "marcelokunze   3_v2",
  "ddd": 0,
  "assets": [],
  "layers": [
      {
          "ddd": 0,
          "ind": 1,
          "ty": 3,
          "nm": "Adjustment Layer 1",
          "sr": 1,
          "ks": {
              "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 11
              },
              "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 10
              },
              "p": {
                  "a": 0,
                  "k": [
                      540,
                      540,
                      0
                  ],
                  "ix": 2,
                  "l": 2
              },
              "a": {
                  "a": 0,
                  "k": [
                      540,
                      540,
                      0
                  ],
                  "ix": 1,
                  "l": 2
              },
              "s": {
                  "a": 0,
                  "k": [
                      100,
                      100,
                      100
                  ],
                  "ix": 6,
                  "l": 2
              }
          },
          "ao": 0,
          "ef": [
              {
                  "ty": 5,
                  "nm": "Invert",
                  "np": 4,
                  "mn": "ADBE Invert",
                  "ix": 1,
                  "en": 1,
                  "ef": [
                      {
                          "ty": 7,
                          "nm": "Channel",
                          "mn": "ADBE Invert-0001",
                          "ix": 1,
                          "v": {
                              "a": 0,
                              "k": 1,
                              "ix": 1
                          }
                      },
                      {
                          "ty": 0,
                          "nm": "Blend With Original",
                          "mn": "ADBE Invert-0002",
                          "ix": 2,
                          "v": {
                              "a": 0,
                              "k": 0,
                              "ix": 2
                          }
                      }
                  ]
              }
          ],
          "ip": -21.0000008553475,
          "op": 279.000011363903,
          "st": -21.0000008553475,
          "bm": 0
      },
      {
          "ddd": 0,
          "ind": 2,
          "ty": 4,
          "nm": "star 1 Outlines",
          "sr": 1,
          "ks": {
              "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 11
              },
              "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 10
              },
              "p": {
                  "a": 0,
                  "k": [
                      522.185,
                      483.019,
                      0
                  ],
                  "ix": 2,
                  "l": 2
              },
              "a": {
                  "a": 0,
                  "k": [
                      41.269,
                      41.27,
                      0
                  ],
                  "ix": 1,
                  "l": 2
              },
              "s": {
                  "a": 1,
                  "k": [
                      {
                          "i": {
                              "x": [
                                  0.15,
                                  0.15,
                                  0.15
                              ],
                              "y": [
                                  1,
                                  1,
                                  1
                              ]
                          },
                          "o": {
                              "x": [
                                  0.23,
                                  0.23,
                                  0.23
                              ],
                              "y": [
                                  0,
                                  0,
                                  0
                              ]
                          },
                          "t": 45,
                          "s": [
                              0,
                              0,
                              100
                          ]
                      },
                      {
                          "i": {
                              "x": [
                                  0.15,
                                  0.15,
                                  0.15
                              ],
                              "y": [
                                  1,
                                  1,
                                  1
                              ]
                          },
                          "o": {
                              "x": [
                                  0.695,
                                  0.695,
                                  0.167
                              ],
                              "y": [
                                  0,
                                  0,
                                  0
                              ]
                          },
                          "t": 74,
                          "s": [
                              100,
                              100,
                              100
                          ]
                      },
                      {
                          "i": {
                              "x": [
                                  0.667,
                                  0.667,
                                  0.667
                              ],
                              "y": [
                                  1,
                                  1,
                                  1
                              ]
                          },
                          "o": {
                              "x": [
                                  0.695,
                                  0.695,
                                  0.167
                              ],
                              "y": [
                                  0,
                                  0,
                                  0
                              ]
                          },
                          "t": 81,
                          "s": [
                              100,
                              100,
                              100
                          ]
                      },
                      {
                          "t": 95.0000038694293,
                          "s": [
                              0,
                              0,
                              100
                          ]
                      }
                  ],
                  "ix": 6,
                  "l": 2
              }
          },
          "ao": 0,
          "shapes": [
              {
                  "ty": "gr",
                  "it": [
                      {
                          "ind": 0,
                          "ty": "sh",
                          "ix": 1,
                          "ks": {
                              "a": 0,
                              "k": {
                                  "i": [
                                      [
                                          -0.883,
                                          -0.263
                                      ],
                                      [
                                          0,
                                          0
                                      ],
                                      [
                                          -0.503,
                                          -0.503
                                      ],
                                      [
                                          -0.203,
                                          -0.682
                                      ],
                                      [
                                          0,
                                          0
                                      ],
                                      [
                                          -0.739,
                                          -0.55
                                      ],
                                      [
                                          -0.921,
                                          0
                                      ],
                                      [
                                          -0.738,
                                          0.552
                                      ],
                                      [
                                          -0.264,
                                          0.883
                                      ],
                                      [
                                          0,
                                          0
                                      ],
                                      [
                                          -0.503,
                                          0.503
                                      ],
                                      [
                                          -0.681,
                                          0.203
                                      ],
                                      [
                                          0,
                                          0
                                      ],
                                      [
                                          -0.551,
                                          0.739
                                      ],
                                      [
                                          0,
                                          0.922
                                      ],
                                      [
                                          0.551,
                                          0.739
                                      ],
                                      [
                                          0.883,
                                          0.264
                                      ],
                                      [
                                          0,
                                          0
                                      ],
                                      [
                                          0.503,
                                          0.502
                                      ],
                                      [
                                          0.203,
                                          0.681
                                      ],
                                      [
                                          0,
                                          0
                                      ],
                                      [
                                          0.739,
                                          0.551
                                      ],
                                      [
                                          0.922,
                                          0
                                      ],
                                      [
                                          0.739,
                                          -0.551
                                      ],
                                      [
                                          0.263,
                                          -0.883
                                      ],
                                      [
                                          0,
                                          0
                                      ],
                                      [
                                          0.503,
                                          -0.503
                                      ],
                                      [
                                          0.681,
                                          -0.202
                                      ],
                                      [
                                          0,
                                          0
                                      ],
                                      [
                                          0.551,
                                          -0.738
                                      ],
                                      [
                                          0,
                                          -0.921
                                      ],
                                      [
                                          -0.551,
                                          -0.739
                                      ]
                                  ],
                                  "o": [
                                      [
                                          0,
                                          0
                                      ],
                                      [
                                          0.681,
                                          0.203
                                      ],
                                      [
                                          0.503,
                                          0.503
                                      ],
                                      [
                                          0,
                                          0
                                      ],
                                      [
                                          0.263,
                                          0.883
                                      ],
                                      [
                                          0.739,
                                          0.552
                                      ],
                                      [
                                          0.922,
                                          0
                                      ],
                                      [
                                          0.739,
                                          -0.55
                                      ],
                                      [
                                          0,
                                          0
                                      ],
                                      [
                                          0.203,
                                          -0.682
                                      ],
                                      [
                                          0.503,
                                          -0.503
                                      ],
                                      [
                                          0,
                                          0
                                      ],
                                      [
                                          0.883,
                                          -0.263
                                      ],
                                      [
                                          0.551,
                                          -0.739
                                      ],
                                      [
                                          0,
                                          -0.921
                                      ],
                                      [
                                          -0.551,
                                          -0.738
                                      ],
                                      [
                                          0,
                                          0
                                      ],
                                      [
                                          -0.681,
                                          -0.202
                                      ],
                                      [
                                          -0.503,
                                          -0.503
                                      ],
                                      [
                                          0,
                                          0
                                      ],
                                      [
                                          -0.264,
                                          -0.883
                                      ],
                                      [
                                          -0.738,
                                          -0.551
                                      ],
                                      [
                                          -0.921,
                                          0
                                      ],
                                      [
                                          -0.739,
                                          0.551
                                      ],
                                      [
                                          0,
                                          0
                                      ],
                                      [
                                          -0.203,
                                          0.681
                                      ],
                                      [
                                          -0.503,
                                          0.502
                                      ],
                                      [
                                          0,
                                          0
                                      ],
                                      [
                                          -0.883,
                                          0.264
                                      ],
                                      [
                                          -0.551,
                                          0.739
                                      ],
                                      [
                                          0,
                                          0.922
                                      ],
                                      [
                                          0.551,
                                          0.739
                                      ]
                                  ],
                                  "v": [
                                      [
                                          -37.962,
                                          4.1
                                      ],
                                      [
                                          -14.089,
                                          11.21
                                      ],
                                      [
                                          -12.285,
                                          12.286
                                      ],
                                      [
                                          -11.21,
                                          14.09
                                      ],
                                      [
                                          -4.1,
                                          37.962
                                      ],
                                      [
                                          -2.557,
                                          40.171
                                      ],
                                      [
                                          0,
                                          41.02
                                      ],
                                      [
                                          2.557,
                                          40.171
                                      ],
                                      [
                                          4.101,
                                          37.962
                                      ],
                                      [
                                          11.21,
                                          14.09
                                      ],
                                      [
                                          12.285,
                                          12.286
                                      ],
                                      [
                                          14.089,
                                          11.21
                                      ],
                                      [
                                          37.962,
                                          4.1
                                      ],
                                      [
                                          40.171,
                                          2.558
                                      ],
                                      [
                                          41.019,
                                          0
                                      ],
                                      [
                                          40.171,
                                          -2.557
                                      ],
                                      [
                                          37.962,
                                          -4.1
                                      ],
                                      [
                                          14.089,
                                          -11.21
                                      ],
                                      [
                                          12.285,
                                          -12.284
                                      ],
                                      [
                                          11.21,
                                          -14.088
                                      ],
                                      [
                                          4.101,
                                          -37.962
                                      ],
                                      [
                                          2.557,
                                          -40.171
                                      ],
                                      [
                                          0,
                                          -41.02
                                      ],
                                      [
                                          -2.557,
                                          -40.171
                                      ],
                                      [
                                          -4.1,
                                          -37.962
                                      ],
                                      [
                                          -11.21,
                                          -14.088
                                      ],
                                      [
                                          -12.285,
                                          -12.284
                                      ],
                                      [
                                          -14.089,
                                          -11.21
                                      ],
                                      [
                                          -37.962,
                                          -4.1
                                      ],
                                      [
                                          -40.171,
                                          -2.557
                                      ],
                                      [
                                          -41.019,
                                          0
                                      ],
                                      [
                                          -40.171,
                                          2.558
                                      ]
                                  ],
                                  "c": true
                              },
                              "ix": 2
                          },
                          "nm": "Path 1",
                          "mn": "ADBE Vector Shape - Group",
                          "hd": false
                      },
                      {
                          "ty": "fl",
                          "c": {
                              "a": 0,
                              "k": [
                                  0,
                                  0,
                                  0,
                                  1
                              ],
                              "ix": 4
                          },
                          "o": {
                              "a": 0,
                              "k": 100,
                              "ix": 5
                          },
                          "r": 1,
                          "bm": 0,
                          "nm": "Fill 1",
                          "mn": "ADBE Vector Graphic - Fill",
                          "hd": false
                      },
                      {
                          "ty": "tr",
                          "p": {
                              "a": 0,
                              "k": [
                                  41.269,
                                  41.27
                              ],
                              "ix": 2
                          },
                          "a": {
                              "a": 0,
                              "k": [
                                  0,
                                  0
                              ],
                              "ix": 1
                          },
                          "s": {
                              "a": 0,
                              "k": [
                                  100,
                                  100
                              ],
                              "ix": 3
                          },
                          "r": {
                              "a": 0,
                              "k": 0,
                              "ix": 6
                          },
                          "o": {
                              "a": 0,
                              "k": 100,
                              "ix": 7
                          },
                          "sk": {
                              "a": 0,
                              "k": 0,
                              "ix": 4
                          },
                          "sa": {
                              "a": 0,
                              "k": 0,
                              "ix": 5
                          },
                          "nm": "Transform"
                      }
                  ],
                  "nm": "Group 1",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
              }
          ],
          "ip": -21.0000008553475,
          "op": 279.000011363903,
          "st": -21.0000008553475,
          "ct": 1,
          "bm": 0
      },
      {
          "ddd": 0,
          "ind": 3,
          "ty": 4,
          "nm": "star 2 Outlines",
          "sr": 1,
          "ks": {
              "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 11
              },
              "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 10
              },
              "p": {
                  "a": 1,
                  "k": [
                      {
                          "i": {
                              "x": 0.667,
                              "y": 1
                          },
                          "o": {
                              "x": 0.693,
                              "y": 0
                          },
                          "t": 37,
                          "s": [
                              540.525,
                              566.696,
                              0
                          ],
                          "to": [
                              9,
                              0,
                              0
                          ],
                          "ti": [
                              -9,
                              0,
                              0
                          ]
                      },
                      {
                          "i": {
                              "x": 0.667,
                              "y": 0.667
                          },
                          "o": {
                              "x": 0.333,
                              "y": 0.333
                          },
                          "t": 62,
                          "s": [
                              594.525,
                              566.696,
                              0
                          ],
                          "to": [
                              0,
                              0,
                              0
                          ],
                          "ti": [
                              0,
                              0,
                              0
                          ]
                      },
                      {
                          "t": 74.0000030140818,
                          "s": [
                              594.525,
                              566.696,
                              0
                          ]
                      }
                  ],
                  "ix": 2,
                  "l": 2
              },
              "a": {
                  "a": 0,
                  "k": [
                      204.258,
                      69.681,
                      0
                  ],
                  "ix": 1,
                  "l": 2
              },
              "s": {
                  "a": 1,
                  "k": [
                      {
                          "i": {
                              "x": [
                                  0.1,
                                  0.1,
                                  0.1
                              ],
                              "y": [
                                  1,
                                  1,
                                  1
                              ]
                          },
                          "o": {
                              "x": [
                                  0.19,
                                  0.19,
                                  0.19
                              ],
                              "y": [
                                  0,
                                  0,
                                  0
                              ]
                          },
                          "t": 0,
                          "s": [
                              0,
                              0,
                              100
                          ]
                      },
                      {
                          "i": {
                              "x": [
                                  0.1,
                                  0.1,
                                  0.1
                              ],
                              "y": [
                                  1,
                                  1,
                                  1
                              ]
                          },
                          "o": {
                              "x": [
                                  0.167,
                                  0.167,
                                  0.167
                              ],
                              "y": [
                                  0,
                                  0,
                                  0
                              ]
                          },
                          "t": 34,
                          "s": [
                              100,
                              100,
                              100
                          ]
                      },
                      {
                          "i": {
                              "x": [
                                  0.315,
                                  0.315,
                                  0.833
                              ],
                              "y": [
                                  1,
                                  1,
                                  1
                              ]
                          },
                          "o": {
                              "x": [
                                  0.281,
                                  0.281,
                                  0.167
                              ],
                              "y": [
                                  0,
                                  0,
                                  0
                              ]
                          },
                          "t": 81,
                          "s": [
                              100,
                              100,
                              100
                          ]
                      },
                      {
                          "t": 95.0000038694293,
                          "s": [
                              0,
                              0,
                              100
                          ]
                      }
                  ],
                  "ix": 6,
                  "l": 2
              }
          },
          "ao": 0,
          "shapes": [
              {
                  "ty": "gr",
                  "it": [
                      {
                          "ind": 0,
                          "ty": "sh",
                          "ix": 1,
                          "ks": {
                              "a": 1,
                              "k": [
                                  {
                                      "i": {
                                          "x": 0.271,
                                          "y": 1
                                      },
                                      "o": {
                                          "x": 0.333,
                                          "y": 0
                                      },
                                      "t": 31,
                                      "s": [
                                          {
                                              "i": [
                                                  [
                                                      -1.495,
                                                      -0.445
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      -0.851,
                                                      -0.852
                                                  ],
                                                  [
                                                      -0.344,
                                                      -1.153
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      -1.25,
                                                      -0.932
                                                  ],
                                                  [
                                                      -1.561,
                                                      0
                                                  ],
                                                  [
                                                      -1.251,
                                                      0.932
                                                  ],
                                                  [
                                                      -0.445,
                                                      1.496
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      -0.852,
                                                      0.85
                                                  ],
                                                  [
                                                      -1.153,
                                                      0.343
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      -0.933,
                                                      1.251
                                                  ],
                                                  [
                                                      0,
                                                      1.56
                                                  ],
                                                  [
                                                      0.932,
                                                      1.25
                                                  ],
                                                  [
                                                      1.496,
                                                      0.445
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      0.85,
                                                      0.851
                                                  ],
                                                  [
                                                      0.344,
                                                      1.154
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      1.251,
                                                      0.933
                                                  ],
                                                  [
                                                      1.559,
                                                      0
                                                  ],
                                                  [
                                                      1.25,
                                                      -0.932
                                                  ],
                                                  [
                                                      0.445,
                                                      -1.495
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      0.851,
                                                      -0.851
                                                  ],
                                                  [
                                                      1.153,
                                                      -0.344
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      0.932,
                                                      -1.251
                                                  ],
                                                  [
                                                      0,
                                                      -1.56
                                                  ],
                                                  [
                                                      -0.933,
                                                      -1.251
                                                  ]
                                              ],
                                              "o": [
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      1.153,
                                                      0.343
                                                  ],
                                                  [
                                                      0.851,
                                                      0.85
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      0.445,
                                                      1.496
                                                  ],
                                                  [
                                                      1.25,
                                                      0.932
                                                  ],
                                                  [
                                                      1.559,
                                                      0
                                                  ],
                                                  [
                                                      1.251,
                                                      -0.932
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      0.344,
                                                      -1.153
                                                  ],
                                                  [
                                                      0.85,
                                                      -0.852
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      1.496,
                                                      -0.445
                                                  ],
                                                  [
                                                      0.932,
                                                      -1.251
                                                  ],
                                                  [
                                                      0,
                                                      -1.56
                                                  ],
                                                  [
                                                      -0.933,
                                                      -1.251
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      -1.153,
                                                      -0.344
                                                  ],
                                                  [
                                                      -0.852,
                                                      -0.851
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      -0.445,
                                                      -1.495
                                                  ],
                                                  [
                                                      -1.251,
                                                      -0.932
                                                  ],
                                                  [
                                                      -1.561,
                                                      0
                                                  ],
                                                  [
                                                      -1.25,
                                                      0.933
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      -0.344,
                                                      1.154
                                                  ],
                                                  [
                                                      -0.851,
                                                      0.851
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      -1.495,
                                                      0.445
                                                  ],
                                                  [
                                                      -0.933,
                                                      1.25
                                                  ],
                                                  [
                                                      0,
                                                      1.559
                                                  ],
                                                  [
                                                      0.932,
                                                      1.251
                                                  ]
                                              ],
                                              "v": [
                                                  [
                                                      -0.834,
                                                      6.896
                                                  ],
                                                  [
                                                      44.729,
                                                      18.975
                                                  ],
                                                  [
                                                      47.783,
                                                      20.794
                                                  ],
                                                  [
                                                      49.603,
                                                      23.848
                                                  ],
                                                  [
                                                      61.637,
                                                      64.255
                                                  ],
                                                  [
                                                      64.249,
                                                      67.995
                                                  ],
                                                  [
                                                      68.578,
                                                      69.431
                                                  ],
                                                  [
                                                      72.906,
                                                      67.995
                                                  ],
                                                  [
                                                      75.518,
                                                      64.255
                                                  ],
                                                  [
                                                      87.551,
                                                      23.848
                                                  ],
                                                  [
                                                      89.372,
                                                      20.794
                                                  ],
                                                  [
                                                      92.425,
                                                      18.975
                                                  ],
                                                  [
                                                      132.833,
                                                      6.94
                                                  ],
                                                  [
                                                      136.572,
                                                      4.328
                                                  ],
                                                  [
                                                      138.008,
                                                      0
                                                  ],
                                                  [
                                                      136.572,
                                                      -4.328
                                                  ],
                                                  [
                                                      132.833,
                                                      -6.94
                                                  ],
                                                  [
                                                      92.425,
                                                      -18.974
                                                  ],
                                                  [
                                                      89.372,
                                                      -20.794
                                                  ],
                                                  [
                                                      87.551,
                                                      -23.848
                                                  ],
                                                  [
                                                      75.518,
                                                      -64.257
                                                  ],
                                                  [
                                                      72.906,
                                                      -67.995
                                                  ],
                                                  [
                                                      68.578,
                                                      -69.431
                                                  ],
                                                  [
                                                      64.249,
                                                      -67.995
                                                  ],
                                                  [
                                                      61.637,
                                                      -64.257
                                                  ],
                                                  [
                                                      49.603,
                                                      -23.848
                                                  ],
                                                  [
                                                      47.783,
                                                      -20.794
                                                  ],
                                                  [
                                                      44.729,
                                                      -18.974
                                                  ],
                                                  [
                                                      -0.834,
                                                      -6.985
                                                  ],
                                                  [
                                                      -4.572,
                                                      -4.373
                                                  ],
                                                  [
                                                      -6.008,
                                                      -0.044
                                                  ],
                                                  [
                                                      -4.572,
                                                      4.284
                                                  ]
                                              ],
                                              "c": true
                                          }
                                      ]
                                  },
                                  {
                                      "i": {
                                          "x": 0.667,
                                          "y": 1
                                      },
                                      "o": {
                                          "x": 0.693,
                                          "y": 0
                                      },
                                      "t": 37,
                                      "s": [
                                          {
                                              "i": [
                                                  [
                                                      -1.495,
                                                      -0.445
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      -0.851,
                                                      -0.852
                                                  ],
                                                  [
                                                      -0.344,
                                                      -1.153
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      -1.25,
                                                      -0.932
                                                  ],
                                                  [
                                                      -1.561,
                                                      0
                                                  ],
                                                  [
                                                      -1.251,
                                                      0.932
                                                  ],
                                                  [
                                                      -0.445,
                                                      1.496
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      -0.852,
                                                      0.85
                                                  ],
                                                  [
                                                      -1.153,
                                                      0.343
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      -0.933,
                                                      1.251
                                                  ],
                                                  [
                                                      0,
                                                      1.56
                                                  ],
                                                  [
                                                      0.932,
                                                      1.25
                                                  ],
                                                  [
                                                      1.496,
                                                      0.445
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      0.85,
                                                      0.851
                                                  ],
                                                  [
                                                      0.344,
                                                      1.154
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      1.251,
                                                      0.933
                                                  ],
                                                  [
                                                      1.559,
                                                      0
                                                  ],
                                                  [
                                                      1.25,
                                                      -0.932
                                                  ],
                                                  [
                                                      0.445,
                                                      -1.495
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      0.851,
                                                      -0.851
                                                  ],
                                                  [
                                                      1.153,
                                                      -0.344
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      0.932,
                                                      -1.251
                                                  ],
                                                  [
                                                      0,
                                                      -1.56
                                                  ],
                                                  [
                                                      -0.933,
                                                      -1.251
                                                  ]
                                              ],
                                              "o": [
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      1.153,
                                                      0.343
                                                  ],
                                                  [
                                                      0.851,
                                                      0.85
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      0.445,
                                                      1.496
                                                  ],
                                                  [
                                                      1.25,
                                                      0.932
                                                  ],
                                                  [
                                                      1.559,
                                                      0
                                                  ],
                                                  [
                                                      1.251,
                                                      -0.932
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      0.344,
                                                      -1.153
                                                  ],
                                                  [
                                                      0.85,
                                                      -0.852
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      1.496,
                                                      -0.445
                                                  ],
                                                  [
                                                      0.932,
                                                      -1.251
                                                  ],
                                                  [
                                                      0,
                                                      -1.56
                                                  ],
                                                  [
                                                      -0.933,
                                                      -1.251
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      -1.153,
                                                      -0.344
                                                  ],
                                                  [
                                                      -0.852,
                                                      -0.851
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      -0.445,
                                                      -1.495
                                                  ],
                                                  [
                                                      -1.251,
                                                      -0.932
                                                  ],
                                                  [
                                                      -1.561,
                                                      0
                                                  ],
                                                  [
                                                      -1.25,
                                                      0.933
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      -0.344,
                                                      1.154
                                                  ],
                                                  [
                                                      -0.851,
                                                      0.851
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      -1.495,
                                                      0.445
                                                  ],
                                                  [
                                                      -0.933,
                                                      1.25
                                                  ],
                                                  [
                                                      0,
                                                      1.559
                                                  ],
                                                  [
                                                      0.932,
                                                      1.251
                                                  ]
                                              ],
                                              "v": [
                                                  [
                                                      -0.834,
                                                      6.896
                                                  ],
                                                  [
                                                      44.729,
                                                      18.975
                                                  ],
                                                  [
                                                      47.783,
                                                      20.794
                                                  ],
                                                  [
                                                      49.603,
                                                      23.848
                                                  ],
                                                  [
                                                      61.637,
                                                      64.255
                                                  ],
                                                  [
                                                      64.249,
                                                      67.995
                                                  ],
                                                  [
                                                      68.578,
                                                      69.431
                                                  ],
                                                  [
                                                      72.906,
                                                      67.995
                                                  ],
                                                  [
                                                      75.518,
                                                      64.255
                                                  ],
                                                  [
                                                      87.551,
                                                      23.848
                                                  ],
                                                  [
                                                      89.372,
                                                      20.794
                                                  ],
                                                  [
                                                      92.425,
                                                      18.975
                                                  ],
                                                  [
                                                      132.833,
                                                      6.94
                                                  ],
                                                  [
                                                      136.572,
                                                      4.328
                                                  ],
                                                  [
                                                      138.008,
                                                      0
                                                  ],
                                                  [
                                                      136.572,
                                                      -4.328
                                                  ],
                                                  [
                                                      132.833,
                                                      -6.94
                                                  ],
                                                  [
                                                      92.425,
                                                      -18.974
                                                  ],
                                                  [
                                                      89.372,
                                                      -20.794
                                                  ],
                                                  [
                                                      87.551,
                                                      -23.848
                                                  ],
                                                  [
                                                      75.518,
                                                      -64.257
                                                  ],
                                                  [
                                                      72.906,
                                                      -67.995
                                                  ],
                                                  [
                                                      68.578,
                                                      -69.431
                                                  ],
                                                  [
                                                      64.249,
                                                      -67.995
                                                  ],
                                                  [
                                                      61.637,
                                                      -64.257
                                                  ],
                                                  [
                                                      49.603,
                                                      -23.848
                                                  ],
                                                  [
                                                      47.783,
                                                      -20.794
                                                  ],
                                                  [
                                                      44.729,
                                                      -18.974
                                                  ],
                                                  [
                                                      -0.834,
                                                      -6.985
                                                  ],
                                                  [
                                                      -4.572,
                                                      -4.373
                                                  ],
                                                  [
                                                      -6.008,
                                                      -0.044
                                                  ],
                                                  [
                                                      -4.572,
                                                      4.284
                                                  ]
                                              ],
                                              "c": true
                                          }
                                      ]
                                  },
                                  {
                                      "i": {
                                          "x": 0.667,
                                          "y": 1
                                      },
                                      "o": {
                                          "x": 0.333,
                                          "y": 0
                                      },
                                      "t": 62,
                                      "s": [
                                          {
                                              "i": [
                                                  [
                                                      -1.495,
                                                      -0.445
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      -0.851,
                                                      -0.852
                                                  ],
                                                  [
                                                      -0.344,
                                                      -1.153
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      -1.25,
                                                      -0.932
                                                  ],
                                                  [
                                                      -1.561,
                                                      0
                                                  ],
                                                  [
                                                      -1.251,
                                                      0.932
                                                  ],
                                                  [
                                                      -0.445,
                                                      1.496
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      -0.852,
                                                      0.85
                                                  ],
                                                  [
                                                      -1.153,
                                                      0.343
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      -0.933,
                                                      1.251
                                                  ],
                                                  [
                                                      0,
                                                      1.56
                                                  ],
                                                  [
                                                      0.932,
                                                      1.25
                                                  ],
                                                  [
                                                      1.496,
                                                      0.445
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      0.85,
                                                      0.851
                                                  ],
                                                  [
                                                      0.344,
                                                      1.154
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      1.251,
                                                      0.933
                                                  ],
                                                  [
                                                      1.559,
                                                      0
                                                  ],
                                                  [
                                                      1.25,
                                                      -0.932
                                                  ],
                                                  [
                                                      0.445,
                                                      -1.495
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      0.851,
                                                      -0.851
                                                  ],
                                                  [
                                                      1.153,
                                                      -0.344
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      0.932,
                                                      -1.251
                                                  ],
                                                  [
                                                      0,
                                                      -1.56
                                                  ],
                                                  [
                                                      -0.933,
                                                      -1.251
                                                  ]
                                              ],
                                              "o": [
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      1.153,
                                                      0.343
                                                  ],
                                                  [
                                                      0.851,
                                                      0.85
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      0.445,
                                                      1.496
                                                  ],
                                                  [
                                                      1.25,
                                                      0.932
                                                  ],
                                                  [
                                                      1.559,
                                                      0
                                                  ],
                                                  [
                                                      1.251,
                                                      -0.932
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      0.344,
                                                      -1.153
                                                  ],
                                                  [
                                                      0.85,
                                                      -0.852
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      1.496,
                                                      -0.445
                                                  ],
                                                  [
                                                      0.932,
                                                      -1.251
                                                  ],
                                                  [
                                                      0,
                                                      -1.56
                                                  ],
                                                  [
                                                      -0.933,
                                                      -1.251
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      -1.153,
                                                      -0.344
                                                  ],
                                                  [
                                                      -0.852,
                                                      -0.851
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      -0.445,
                                                      -1.495
                                                  ],
                                                  [
                                                      -1.251,
                                                      -0.932
                                                  ],
                                                  [
                                                      -1.561,
                                                      0
                                                  ],
                                                  [
                                                      -1.25,
                                                      0.933
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      -0.344,
                                                      1.154
                                                  ],
                                                  [
                                                      -0.851,
                                                      0.851
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      -1.495,
                                                      0.445
                                                  ],
                                                  [
                                                      -0.933,
                                                      1.25
                                                  ],
                                                  [
                                                      0,
                                                      1.559
                                                  ],
                                                  [
                                                      0.932,
                                                      1.251
                                                  ]
                                              ],
                                              "v": [
                                                  [
                                                      -132.834,
                                                      6.94
                                                  ],
                                                  [
                                                      44.729,
                                                      18.975
                                                  ],
                                                  [
                                                      47.783,
                                                      20.794
                                                  ],
                                                  [
                                                      49.603,
                                                      23.848
                                                  ],
                                                  [
                                                      61.637,
                                                      64.255
                                                  ],
                                                  [
                                                      64.249,
                                                      67.995
                                                  ],
                                                  [
                                                      68.578,
                                                      69.431
                                                  ],
                                                  [
                                                      72.906,
                                                      67.995
                                                  ],
                                                  [
                                                      75.518,
                                                      64.255
                                                  ],
                                                  [
                                                      87.551,
                                                      23.848
                                                  ],
                                                  [
                                                      89.372,
                                                      20.794
                                                  ],
                                                  [
                                                      92.425,
                                                      18.975
                                                  ],
                                                  [
                                                      132.833,
                                                      6.94
                                                  ],
                                                  [
                                                      136.572,
                                                      4.328
                                                  ],
                                                  [
                                                      138.008,
                                                      0
                                                  ],
                                                  [
                                                      136.572,
                                                      -4.328
                                                  ],
                                                  [
                                                      132.833,
                                                      -6.94
                                                  ],
                                                  [
                                                      92.425,
                                                      -18.974
                                                  ],
                                                  [
                                                      89.372,
                                                      -20.794
                                                  ],
                                                  [
                                                      87.551,
                                                      -23.848
                                                  ],
                                                  [
                                                      75.518,
                                                      -64.257
                                                  ],
                                                  [
                                                      72.906,
                                                      -67.995
                                                  ],
                                                  [
                                                      68.578,
                                                      -69.431
                                                  ],
                                                  [
                                                      64.249,
                                                      -67.995
                                                  ],
                                                  [
                                                      61.637,
                                                      -64.257
                                                  ],
                                                  [
                                                      49.603,
                                                      -23.848
                                                  ],
                                                  [
                                                      47.783,
                                                      -20.794
                                                  ],
                                                  [
                                                      44.729,
                                                      -18.974
                                                  ],
                                                  [
                                                      -132.834,
                                                      -6.94
                                                  ],
                                                  [
                                                      -136.572,
                                                      -4.328
                                                  ],
                                                  [
                                                      -138.008,
                                                      0.001
                                                  ],
                                                  [
                                                      -136.572,
                                                      4.328
                                                  ]
                                              ],
                                              "c": true
                                          }
                                      ]
                                  },
                                  {
                                      "t": 74.0000030140818,
                                      "s": [
                                          {
                                              "i": [
                                                  [
                                                      -1.495,
                                                      -0.445
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      -0.851,
                                                      -0.852
                                                  ],
                                                  [
                                                      -0.344,
                                                      -1.153
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      -1.25,
                                                      -0.932
                                                  ],
                                                  [
                                                      -1.561,
                                                      0
                                                  ],
                                                  [
                                                      -1.251,
                                                      0.932
                                                  ],
                                                  [
                                                      -0.445,
                                                      1.496
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      -0.852,
                                                      0.85
                                                  ],
                                                  [
                                                      -1.153,
                                                      0.343
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      -0.933,
                                                      1.251
                                                  ],
                                                  [
                                                      0,
                                                      1.56
                                                  ],
                                                  [
                                                      0.932,
                                                      1.25
                                                  ],
                                                  [
                                                      1.496,
                                                      0.445
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      0.85,
                                                      0.851
                                                  ],
                                                  [
                                                      0.344,
                                                      1.154
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      1.251,
                                                      0.933
                                                  ],
                                                  [
                                                      1.559,
                                                      0
                                                  ],
                                                  [
                                                      1.25,
                                                      -0.932
                                                  ],
                                                  [
                                                      0.445,
                                                      -1.495
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      0.851,
                                                      -0.851
                                                  ],
                                                  [
                                                      1.153,
                                                      -0.344
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      0.932,
                                                      -1.251
                                                  ],
                                                  [
                                                      0,
                                                      -1.56
                                                  ],
                                                  [
                                                      -0.933,
                                                      -1.251
                                                  ]
                                              ],
                                              "o": [
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      1.153,
                                                      0.343
                                                  ],
                                                  [
                                                      0.851,
                                                      0.85
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      0.445,
                                                      1.496
                                                  ],
                                                  [
                                                      1.25,
                                                      0.932
                                                  ],
                                                  [
                                                      1.559,
                                                      0
                                                  ],
                                                  [
                                                      1.251,
                                                      -0.932
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      0.344,
                                                      -1.153
                                                  ],
                                                  [
                                                      0.85,
                                                      -0.852
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      1.496,
                                                      -0.445
                                                  ],
                                                  [
                                                      0.932,
                                                      -1.251
                                                  ],
                                                  [
                                                      0,
                                                      -1.56
                                                  ],
                                                  [
                                                      -0.933,
                                                      -1.251
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      -1.153,
                                                      -0.344
                                                  ],
                                                  [
                                                      -0.852,
                                                      -0.851
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      -0.445,
                                                      -1.495
                                                  ],
                                                  [
                                                      -1.251,
                                                      -0.932
                                                  ],
                                                  [
                                                      -1.561,
                                                      0
                                                  ],
                                                  [
                                                      -1.25,
                                                      0.933
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      -0.344,
                                                      1.154
                                                  ],
                                                  [
                                                      -0.851,
                                                      0.851
                                                  ],
                                                  [
                                                      0,
                                                      0
                                                  ],
                                                  [
                                                      -1.495,
                                                      0.445
                                                  ],
                                                  [
                                                      -0.933,
                                                      1.25
                                                  ],
                                                  [
                                                      0,
                                                      1.559
                                                  ],
                                                  [
                                                      0.932,
                                                      1.251
                                                  ]
                                              ],
                                              "v": [
                                                  [
                                                      -132.834,
                                                      6.94
                                                  ],
                                                  [
                                                      44.729,
                                                      18.975
                                                  ],
                                                  [
                                                      47.783,
                                                      20.794
                                                  ],
                                                  [
                                                      49.603,
                                                      23.848
                                                  ],
                                                  [
                                                      61.637,
                                                      64.255
                                                  ],
                                                  [
                                                      64.249,
                                                      67.995
                                                  ],
                                                  [
                                                      68.578,
                                                      69.431
                                                  ],
                                                  [
                                                      72.906,
                                                      67.995
                                                  ],
                                                  [
                                                      75.518,
                                                      64.255
                                                  ],
                                                  [
                                                      87.551,
                                                      23.848
                                                  ],
                                                  [
                                                      89.372,
                                                      20.794
                                                  ],
                                                  [
                                                      92.425,
                                                      18.975
                                                  ],
                                                  [
                                                      132.833,
                                                      6.94
                                                  ],
                                                  [
                                                      136.572,
                                                      4.328
                                                  ],
                                                  [
                                                      138.008,
                                                      0
                                                  ],
                                                  [
                                                      136.572,
                                                      -4.328
                                                  ],
                                                  [
                                                      132.833,
                                                      -6.94
                                                  ],
                                                  [
                                                      92.425,
                                                      -18.974
                                                  ],
                                                  [
                                                      89.372,
                                                      -20.794
                                                  ],
                                                  [
                                                      87.551,
                                                      -23.848
                                                  ],
                                                  [
                                                      75.518,
                                                      -64.257
                                                  ],
                                                  [
                                                      72.906,
                                                      -67.995
                                                  ],
                                                  [
                                                      68.578,
                                                      -69.431
                                                  ],
                                                  [
                                                      64.249,
                                                      -67.995
                                                  ],
                                                  [
                                                      61.637,
                                                      -64.257
                                                  ],
                                                  [
                                                      49.603,
                                                      -23.848
                                                  ],
                                                  [
                                                      47.783,
                                                      -20.794
                                                  ],
                                                  [
                                                      44.729,
                                                      -18.974
                                                  ],
                                                  [
                                                      -132.834,
                                                      -6.94
                                                  ],
                                                  [
                                                      -136.572,
                                                      -4.328
                                                  ],
                                                  [
                                                      -138.008,
                                                      0.001
                                                  ],
                                                  [
                                                      -136.572,
                                                      4.328
                                                  ]
                                              ],
                                              "c": true
                                          }
                                      ]
                                  }
                              ],
                              "ix": 2
                          },
                          "nm": "Path 1",
                          "mn": "ADBE Vector Shape - Group",
                          "hd": false
                      },
                      {
                          "ty": "fl",
                          "c": {
                              "a": 0,
                              "k": [
                                  0,
                                  0,
                                  0,
                                  1
                              ],
                              "ix": 4
                          },
                          "o": {
                              "a": 0,
                              "k": 100,
                              "ix": 5
                          },
                          "r": 1,
                          "bm": 0,
                          "nm": "Fill 1",
                          "mn": "ADBE Vector Graphic - Fill",
                          "hd": false
                      },
                      {
                          "ty": "tr",
                          "p": {
                              "a": 0,
                              "k": [
                                  138.258,
                                  69.681
                              ],
                              "ix": 2
                          },
                          "a": {
                              "a": 0,
                              "k": [
                                  0,
                                  0
                              ],
                              "ix": 1
                          },
                          "s": {
                              "a": 0,
                              "k": [
                                  100,
                                  100
                              ],
                              "ix": 3
                          },
                          "r": {
                              "a": 0,
                              "k": 0,
                              "ix": 6
                          },
                          "o": {
                              "a": 0,
                              "k": 100,
                              "ix": 7
                          },
                          "sk": {
                              "a": 0,
                              "k": 0,
                              "ix": 4
                          },
                          "sa": {
                              "a": 0,
                              "k": 0,
                              "ix": 5
                          },
                          "nm": "Transform"
                      }
                  ],
                  "nm": "Group 1",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
              }
          ],
          "ip": -21.0000008553475,
          "op": 135.000005498663,
          "st": -21.0000008553475,
          "ct": 1,
          "bm": 0
      }
  ],
  "markers": [],
  "props": {}
}